import { writable } from "svelte/store";
import { service } from "./services";
import type { ApiResultOfListOfKioskCashSummaryDTO, ApiResultOfListOfKioskStateDTO, KioskCashSummaryDTO, KioskStateDTO } from "./walletapi";

export const kiosks = writable<KioskStateDTO[]>([]);
export const kioskCashSummaries = writable<KioskCashSummaryDTO[]>([]);

export async function RefreshKiosks() {
    try {
        let response: ApiResultOfListOfKioskStateDTO = await service.walletapi.kioskList({
            Token: sessionStorage.token,
        });

        if (response.Success && response.Data) {
            kiosks.set(response.Data);
        } else {
            console.error('Error getting kiosk list:', response.ErrorMessage);
        }
    } catch (error) {
        console.error('API call error:', error);
    }
}

// Each kiosk's cash events between start and end, added up. Returns the error message, if any.
export async function RefreshKioskCashSummaries(start: Date, end: Date): Promise<string | undefined> {
    try {
        let response: ApiResultOfListOfKioskCashSummaryDTO = await service.walletapi.kioskCashSummary({
            Token: sessionStorage.token,
            Data: {
                KioskId: undefined,
                StartDate: start,
                EndDate: end,
            },
        });

        if (response.Success && response.Data) {
            kioskCashSummaries.set(response.Data);
            return undefined;
        }

        console.error('Error getting kiosk cash summary:', response.ErrorMessage);
        return response.ErrorMessage ?? 'Error';
    } catch (error) {
        console.error('API call error:', error);
        return String(error);
    }
}
